import React from 'react';
import TalentMatchDetails from "../talent/TalentMatchDetails";

const MatchScoreTab = ({candidate, projectId, position}) => {

    return (
        <React.Fragment>
            <div className="proposal-padding pb-0">
                <h3 className="proposal-tab-header my-0">
                    Match Summary:
                </h3>
            </div>
            <div className="match-proposal-tab">
                <TalentMatchDetails
                    hideHeader={true}
                    criteria={{...(candidate || {}), ...(position || {})}}
                    showCarousel={true}
                    positionId={position?.id}
                    projectId={projectId}
                    talent={candidate}
                />
            </div>
        </React.Fragment>
    );
};

export default MatchScoreTab;
